import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-v-small', 'LetterVSmall', [["path",{"d":"M10 8l2 8l2 -8","key":"svg-0"}]]);